export const rollcallemployeeslistdata = [
    {
        id: 1,
        name: "John Doe",
        biometric: "BIO12345",
        mobile: "9876543210",
        designation: "Software Engineer",
        department: "IT",
        branch: "Head Office",
        dateOfBirth: "15-04-1990",
        badge: "PC-1001",
        actions: "Edit, View",
    },
    {
        id: 2,
        name: "Jane Smith",
        biometric: "BIO12346",
        mobile: "9876543211",
        designation: "HR Manager",
        department: "HR",
        branch: "Regional Office - North",
        dateOfBirth: "22-08-1985",
        badge: "PC-1002",
        actions: "Edit, View",
    },
    {
        id: 3,
        name: "Amit Kumar",
        biometric: "BIO12347",
        mobile: "9876543212",
        designation: "Accountant",
        department: "Finance",
        branch: "Regional Office - East",
        dateOfBirth: "12-12-1987",
        badge: "PC-1003",
        actions: "Edit, View",
    },
    {
        id: 4,
        name: "Priya Sharma",
        biometric: "BIO12348",
        mobile: "9876543213",
        designation: "Marketing Executive",
        department: "Marketing",
        branch: "Branch Office - South",
        dateOfBirth: "05-06-1992",
        badge: "PC-1004",
        actions: "Edit, View",
    },
    {
        id: 5,
        name: "Robert Brown",
        biometric: "BIO12349",
        mobile: "9876543214",
        designation: "Product Manager",
        department: "Product",
        branch: "Head Office",
        dateOfBirth: "17-11-1983",
        badge: "PC-1005",
        actions: "Edit, View",
    },
    {
        id: 6,
        name: "Maria Lopez",
        biometric: "BIO12350",
        mobile: "9876543215",
        designation: "UI/UX Designer",
        department: "Design",
        branch: "Branch Office - West",
        dateOfBirth: "09-09-1990",
        badge: "PC-1006",
        actions: "Edit, View",
    },
    {
        id: 7,
        name: "Sunil Gupta",
        biometric: "BIO12351",
        mobile: "9876543216",
        designation: "DevOps Engineer",
        department: "IT",
        branch: "Head Office",
        dateOfBirth: "03-03-1988",
        badge: "PC-1007",
        actions: "Edit, View",
    },
    {
        id: 8,
        name: "Emily Clark",
        biometric: "BIO12352",
        mobile: "9876543217",
        designation: "Business Analyst",
        department: "Operations",
        branch: "Regional Office - West",
        dateOfBirth: "28-02-1986",
        badge: "PC-1008",
        actions: "Edit, View",
    },
    {
        id: 9,
        name: "Ravi Verma",
        biometric: "BIO12353",
        mobile: "9876543218",
        designation: "Legal Advisor",
        department: "Legal",
        branch: "Regional Office - North",
        dateOfBirth: "14-07-1979",
        badge: "PC-1009",
        actions: "Edit, View",
    },
    {
        id: 10,
        name: "Sophia Martinez",
        biometric: "BIO12354",
        mobile: "9876543219",
        designation: "Sales Manager",
        department: "Sales",
        branch: "Branch Office - South",
        dateOfBirth: "19-10-1984",
        badge: "PC-1010",
        actions: "Edit, View",
    },
    {
        id: 11,
        name: "Vikram Singh",
        biometric: "BIO12355",
        mobile: "9876543220",
        designation: "QA Engineer",
        department: "Quality",
        branch: "Head Office",
        dateOfBirth: "26-05-1991",
        badge: "PC-1011",
        actions: "Edit, View",
    },
    {
        id: 12,
        name: "Lisa Kim",
        biometric: "BIO12356",
        mobile: "9876543221",
        designation: "Content Writer",
        department: "Content",
        branch: "Regional Office - East",
        dateOfBirth: "11-01-1993",
        badge: "PC-1012",
        actions: "Edit, View",
    },
];
